import { Component, computed, OnInit, Signal } from '@angular/core';
import { ContentComponent } from '../../components/content/content.component';
import { BreadcrumbsComponent } from '../../common/breadcrumbs/breadcrumbs.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PaymentForm } from './payment.form';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { PaymentCommonService } from '../../services/payment.common.service';
import { ValidationErrorsComponent } from '../../common/validation-errors/validation-errors.component';
import { CommonModule } from '@angular/common';
import { LabelComponent } from '../../common/label/label.component';
import { AlertComponent } from '../../common/alert/alert.component';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../services/ssession.service';
import { UserDetails } from '../../store/reducers/user-details.reducer';
import { selectUser } from '../../store/selectors/user-details.selectors';
import { loadUserDetails } from '../../store/actions/user-details.actions';
import { ToNumberPipe } from '../../pipes/to-number.pipe';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'app-payments-page',
  standalone: true,
  imports: [
    CommonModule,
    ContentComponent,
    BreadcrumbsComponent,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    LabelComponent,
    RouterModule,
    AlertComponent,
    ToNumberPipe,
    NgxMaskDirective
  ],
  providers: [PaymentForm],
  templateUrl: './payments-page.component.html'
})
export class PaymentsPageComponent implements OnInit {

  public paymentToken: string | undefined = this.route.snapshot.queryParams['payum_token'] || this.route.snapshot.queryParams['amp;payum_token'];

  public appId: string | undefined = this.route.snapshot.queryParams['appId'];

  public authed: boolean = SessionService.Authed();

  public user: Signal<UserDetails | null> = this.store$.selectSignal(selectUser);

  constructor(
    private store$: Store,
    private route: ActivatedRoute,
    private router: Router,
    private paymentCommonService: PaymentCommonService,
    public form: PaymentForm
  ) {
  }

  public onPastDataFromPortal(): void {
    this.form?.readApplicantDataFromPortal(this.user());
  }

  public onPastDataFromLoginGov(): void {
    this.form?.readApplicantDataFromGovPl(SessionService.GetTokenData());
  }

  public submit(): void {
    if (this.form.valid) {
      this.paymentCommonService.goToPay(this.form.toWriteModel())
        .toPromise().then();
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnInit(): void {
    if (this.route.snapshot.queryParams['token']) {
      SessionService.SetAccessToken(this.route.snapshot.queryParams['token']);
      this.router.navigate([], {
        relativeTo: this.route
      }).finally(() => location.reload());
    }

    if (this.authed) {
      this.store$.dispatch(loadUserDetails());
    }
    this.form.paymentCategories$.subscribe(c => {
      this.form.get('paymentCategory')?.setValue('c48f7801-7fa6-4f37-8502-d340a4a2a2fb');
      this.form.paymentCategoryChange('c48f7801-7fa6-4f37-8502-d340a4a2a2fb');
    });
    switch (true) {
      case !!this.paymentToken && !!this.appId: {
        this.router.navigateByUrl('/platnosci-online/' + this.paymentToken + '/' + this.appId);
        break;
      }
      case !!this.paymentToken: {
        this.router.navigateByUrl('/platnosci-online/' + this.paymentToken);
        break;
      }
      default: {
        // do nothing
      }
    }
  }
}
